import fetchPonyfill from 'fetch-ponyfill';

import * as iter from '../utils/iter';

const {
	fetch,
	Headers,
	Request,
	Response,
} = fetchPonyfill({Promise});

export {
	fetch,
	Headers,
	Request,
	Response,
};

/**
 * @param {Object<string, string> | Iterable<[string, string]>} params
 * @returns {string} ...
 */
export function encodeGetParams(params) {
	if (typeof params === 'object' && !Array.isArray(params)) {
		params = Object.entries(params);
	}

	const res = iter.from(params)
		.map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
		.reduce((acc, s) => `${acc}&${s}`, '');

	if (res.length === 0) {
		return '';
	}
	return `?${res}`;
}
